/* ============================================================
   SACS.A · Terminal de viaje — JS del tema (vanilla, sin deps)
   Port del sitio Next: split-flap, intro banda de equipaje,
   cursor etiqueta, carrito AJAX (iniciales = line item properties),
   catálogo con grupos, ficha con preview de bordado en vivo.
   ============================================================ */
(function () {
  'use strict';

  var CFG = window.SACS || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var reducido = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ss(key, val) {
    try {
      if (val === undefined) return sessionStorage.getItem(key);
      sessionStorage.setItem(key, val);
    } catch (e) { return null; }
  }

  var nfCop = new Intl.NumberFormat('es-CO', { maximumFractionDigits: 0 });
  function fmtCop(cents) { return '$' + nfCop.format(Math.round(cents / 100)); }
  function fmtPesos(pesos) { return '$' + nfCop.format(Math.round(pesos)); }
  function waUrl(msg) { return 'https://wa.me/' + (CFG.whatsapp || '') + '?text=' + encodeURIComponent(msg); }
  function norm(s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function cdn(src, w) {
    if (!src) return src;
    if (/[?&]width=\d+/.test(src)) return src.replace(/([?&])width=\d+/, '$1width=' + w);
    return src + (src.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w;
  }

  /* ---------- Despacho: corte 6 p. m., domingos no ---------- */
  function estadoDespacho() {
    var ahora = new Date();
    var corte = new Date(ahora);
    corte.setHours(CFG.corteHora || 18, 0, 0, 0);
    if (ahora.getDay() === 0 || ahora >= corte) return { saleHoy: false };
    return { saleHoy: true, msRestante: corte.getTime() - ahora.getTime() };
  }
  function formatoRestante(ms) {
    var h = Math.floor(ms / 3600000);
    var m = Math.floor((ms % 3600000) / 60000);
    return h > 0 ? h + 'h ' + m + 'min' : m + 'min';
  }

  /* ---------- Reveal al hacer scroll ---------- */
  function initReveal(raiz) {
    var els = $$('[data-rv]:not(.rv-in)', raiz);
    if (!els.length) return;
    if (reducido || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('rv-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('rv-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -60px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Split-flap ---------- */
  var FLAP_CHARS = 'ABCDEFGHIJKLMNOPQRSTUVWXYZÑ0123456789·.&';
  function initFlap(el) {
    var words;
    try { words = JSON.parse(el.getAttribute('data-words')); } catch (e) { return; }
    if (!words || !words.length) return;
    var intervalo = parseInt(el.getAttribute('data-interval') || '3000', 10);
    var ancho = words.reduce(function (m, w) { return Math.max(m, w.length); }, 0);
    el.textContent = '';
    el.setAttribute('role', 'text');
    if (!el.getAttribute('aria-label')) el.setAttribute('aria-label', words.join(', '));
    var celdas = [];
    for (var i = 0; i < ancho; i++) {
      var c = document.createElement('span');
      c.className = 'flap-cell';
      c.setAttribute('aria-hidden', 'true');
      c.textContent = ' ';
      el.appendChild(c);
      celdas.push(c);
    }
    var tick = null, idx = 0;
    function girarA(palabra) {
      var goal = palabra;
      while (goal.length < ancho) goal += ' ';
      if (reducido) {
        celdas.forEach(function (c, i) { c.textContent = goal[i] === ' ' ? ' ' : goal[i]; });
        return;
      }
      var settle = [];
      for (var i = 0; i < ancho; i++) settle.push(6 + i * 2);
      var t = 0;
      if (tick) clearInterval(tick);
      celdas.forEach(function (c) { c.classList.add('gira'); });
      tick = setInterval(function () {
        t++;
        celdas.forEach(function (c, i) {
          if (t >= settle[i]) {
            c.textContent = goal[i] === ' ' ? ' ' : goal[i];
            c.classList.remove('gira');
          } else {
            c.textContent = FLAP_CHARS[Math.floor(Math.random() * FLAP_CHARS.length)];
          }
        });
        if (t >= settle[ancho - 1]) { clearInterval(tick); tick = null; }
      }, 55);
    }
    setTimeout(function () { girarA(words[0]); }, 120);
    if (words.length > 1) {
      setInterval(function () {
        idx = (idx + 1) % words.length;
        girarA(words[idx]);
      }, intervalo);
    }
  }

  /* ---------- Intro banda de equipaje ---------- */
  function initIntro() {
    var el = $('[data-intro]');
    if (!el) return;
    if (reducido || ss('sacs-intro-vista')) { el.remove(); return; }
    ss('sacs-intro-vista', '1');
    el.hidden = false;
    document.documentElement.classList.add('con-intro');
    $$('[data-flap]', el).forEach(initFlap);
    var salioYa = false;
    function salir() {
      if (salioYa) return;
      salioYa = true;
      el.classList.add('saliendo');
      setTimeout(function () {
        el.remove();
        document.documentElement.classList.remove('con-intro');
      }, 780);
    }
    el.addEventListener('click', salir);
    setTimeout(salir, 2500);
  }

  /* ---------- Cursor etiqueta de equipaje ---------- */
  function initCursor() {
    var el = $('#cursor');
    if (!el) return;
    if (document.body.getAttribute('data-cursor-flag') === '0') { el.remove(); return; }
    if (!window.matchMedia('(pointer: fine)').matches || reducido) return;
    document.body.setAttribute('data-cursor-custom', '');
    el.hidden = false;
    var tx = -100, ty = -100, x = -100, y = -100, activo = false;
    document.addEventListener('mousemove', function (e) {
      tx = e.clientX; ty = e.clientY;
      var sobre = e.target.closest && e.target.closest('a, button, [role="button"], summary, [data-cursor]');
      el.classList.remove('m-link', 'm-ver');
      if (sobre) {
        el.classList.add(sobre.getAttribute && sobre.getAttribute('data-cursor') === 'ver' ? 'm-ver' : 'm-link');
      }
      if (!activo) { activo = true; x = tx; y = ty; loop(); }
    }, { passive: true });
    function loop() {
      x += (tx - x) * 0.3;
      y += (ty - y) * 0.3;
      el.style.transform = 'translate(' + x + 'px,' + y + 'px)';
      requestAnimationFrame(loop);
    }
  }

  /* Alto REAL del encabezado → --anuncio-real / --nav-real (y de ahí --tope).
     Los altos de la hoja son solo el punto de partida: si un mensaje cae en
     dos líneas (pantalla angosta, tipografía inflada por el navegador de
     Instagram/Facebook), el nav pegajoso tiene que bajar con la barra o la
     tapa. Con ResizeObserver se recalcula ante cualquier cambio.

     REGLA: se escribe en variables APARTE de las que dimensionan (--anuncio-h,
     --nav-h). Escribir en las mismas es un lazo infinito: lo medido incluye el
     borde del nav, así que cada pasada sumaba 1px y el ResizeObserver volvía a
     dispararse → la barra bajaba como cortina hasta tapar la tienda (13-ago). */
  function medirEncabezado() {
    var anuncio = $('.anuncio');
    var nav = $('.nav');
    var raiz = document.documentElement;
    var ultA = -1, ultN = -1; // -1 = todavía sin medir (0 es un alto válido)
    var aplica = function () {
      // Sin barra (la dueña puede dejar la sección sin mensajes) el alto es 0:
      // hay que escribirlo igual, o el nav se pegaría a los 32px del piso y
      // dejaría un hueco encima.
      var ha = anuncio ? Math.round(anuncio.getBoundingClientRect().height) : 0;
      var hn = nav ? Math.round(nav.getBoundingClientRect().height) : 0;
      if (ha !== ultA) { ultA = ha; raiz.style.setProperty('--anuncio-real', ha + 'px'); }
      if (hn && hn !== ultN) { ultN = hn; raiz.style.setProperty('--nav-real', hn + 'px'); }
    };
    aplica();
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(aplica);
      if (anuncio) ro.observe(anuncio);
      if (nav) ro.observe(nav);
    } else {
      window.addEventListener('resize', aplica, { passive: true });
    }
    // Las fuentes web cambian el alto al cargar: una pasada más al terminar.
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(aplica);
  }

  /* ---------- Anuncio rotativo + sombra del nav ---------- */
  function initNav() {
    medirEncabezado();
    var msgs = $$('.anuncio-msg');
    if (msgs.length > 1) {
      var a = 0;
      setInterval(function () {
        msgs[a].classList.remove('activa');
        a = (a + 1) % msgs.length;
        msgs[a].classList.add('activa');
      }, 4200);
    }
    var nav = $('.nav');
    if (nav) {
      var onScroll = function () { nav.classList.toggle('con-sombra', window.scrollY > 8); };
      onScroll();
      window.addEventListener('scroll', onScroll, { passive: true });
    }
    var menu = $('#menu-movil');
    var abrir = $('[data-menu-abrir]');
    var cerrar = $('[data-menu-cerrar]');
    if (menu && abrir) {
      abrir.addEventListener('click', function () {
        menu.hidden = false;
        requestAnimationFrame(function () { menu.classList.add('abierto'); });
      });
      var cierra = function () { menu.classList.remove('abierto'); setTimeout(function(){ menu.hidden = true; }, 260); };
      if (cerrar) cerrar.addEventListener('click', cierra);
      $$('a', menu).forEach(function (ln) { ln.addEventListener('click', cierra); });
    }
  }

  /* ---------- Carrito (AJAX + drawer) ---------- */
  var Carrito = {
    datos: null,
    fetch: function () {
      return window.fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) { Carrito.datos = c; Carrito.pintar(); return c; });
    },
    add: function (items) {
      return window.fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      }).then(function () {
        return Carrito.fetch();
      }).then(function () {
        Carrito.abrir();
      });
    },
    cambiar: function (key, qty) {
      return window.fetch('/cart/change.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); })
        .then(function (c) { Carrito.datos = c; Carrito.pintar(); });
    },
    abrir: function () {
      document.body.classList.add('drawer-abierto');
      if (!Carrito.datos) Carrito.fetch();
    },
    cerrar: function () { document.body.classList.remove('drawer-abierto'); },
    mensajeWA: function () {
      var c = Carrito.datos;
      if (!c || !c.items.length) return waUrl('Hola SACS.A 👋 Quiero hacer un pedido');
      var lineas = c.items.map(function (i) {
        var extra = [];
        if (i.variant_title && i.variant_title !== 'Default Title') extra.push(i.variant_title);
        if (i.properties) {
          Object.keys(i.properties).forEach(function (k) {
            if (i.properties[k]) extra.push(k + ': ' + i.properties[k]);
          });
        }
        return '• ' + i.product_title + (extra.length ? ' · ' + extra.join(' · ') : '') +
          ' × ' + i.quantity + ' — ' + fmtCop(i.final_line_price);
      });
      return waUrl('Hola SACS.A 👋 Quiero hacer este pedido:\n\n' + lineas.join('\n') +
        '\n\nTotal: ' + fmtCop(c.total_price));
    },
    pintar: function () {
      var c = Carrito.datos;
      if (!c) return;
      $$('[data-carrito-n]').forEach(function (b) {
        b.textContent = c.item_count > 0 ? c.item_count : '';
        if (c.item_count > 0) b.removeAttribute('data-cero');
        else b.setAttribute('data-cero', '');
      });
      var lista = $('[data-drawer-items]');
      var vacio = $('[data-drawer-vacio]');
      var pie = $('[data-drawer-pie]');
      if (!lista) return;
      if (!c.items.length) {
        lista.hidden = true; if (pie) pie.hidden = true;
        if (vacio) vacio.hidden = false;
      } else {
        if (vacio) vacio.hidden = true;
        lista.hidden = false; if (pie) pie.hidden = false;
        lista.innerHTML = c.items.map(function (i) {
          var extra = [];
          if (i.variant_title && i.variant_title !== 'Default Title') extra.push(i.variant_title);
          if (i.properties) {
            Object.keys(i.properties).forEach(function (k) {
              if (i.properties[k]) extra.push(esc(k) + ': ' + esc(i.properties[k]));
            });
          }
          return '<li class="ditem">' +
            '<div class="ditem-foto">' + (i.image ? '<img src="' + esc(cdn(i.image, 128)) + '" alt="" loading="lazy">' : '') + '</div>' +
            '<div class="ditem-cuerpo">' +
              '<div class="ditem-fila">' +
                '<p class="ditem-nombre">' + esc(i.product_title) +
                  (extra.length ? '<span class="ditem-variante">' + extra.join(' · ') + '</span>' : '') +
                '</p>' +
                '<p class="ditem-precio">' + fmtCop(i.final_line_price) + '</p>' +
              '</div>' +
              '<div class="ditem-qty">' +
                '<button type="button" data-qty-menos="' + esc(i.key) + '" data-qty-n="' + i.quantity + '" aria-label="Quitar una unidad de ' + esc(i.product_title) + '">−</button>' +
                '<span class="n">' + i.quantity + '</span>' +
                '<button type="button" data-qty-mas="' + esc(i.key) + '" data-qty-n="' + i.quantity + '" aria-label="Agregar una unidad de ' + esc(i.product_title) + '">+</button>' +
              '</div>' +
            '</div></li>';
        }).join('');
      }
      var totalEl = $('[data-drawer-total]');
      if (totalEl) totalEl.textContent = fmtCop(c.total_price);
      var wa = $('[data-drawer-wa]');
      if (wa) wa.href = Carrito.mensajeWA();
      var meta = CFG.envioGratis || 0;
      var falta = Math.max(0, meta - c.total_price);
      var msgEl = $('[data-envio-msg]');
      if (msgEl && meta > 0) {
        msgEl.innerHTML = falta > 0
          ? 'Te faltan <strong>' + fmtCop(falta) + '</strong> para el envío gratis'
          : '<span class="listo">¡Tienes envío gratis!</span>';
      }
      var barra = $('[data-envio-barra]');
      if (barra && meta > 0) {
        var p = Math.min(1, c.total_price / meta);
        barra.style.width = (p * 100) + '%';
        var prog = barra.closest('[role="progressbar"]');
        if (prog) prog.setAttribute('aria-valuenow', Math.round(p * 100));
      }
    }
  };

  function initCarrito() {
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-carrito-abrir]')) { e.preventDefault(); Carrito.abrir(); return; }
      if (t.closest('[data-carrito-cerrar]')) { Carrito.cerrar(); return; }
      var menos = t.closest('[data-qty-menos]');
      if (menos) { Carrito.cambiar(menos.getAttribute('data-qty-menos'), parseInt(menos.getAttribute('data-qty-n'), 10) - 1); return; }
      var mas = t.closest('[data-qty-mas]');
      if (mas) { Carrito.cambiar(mas.getAttribute('data-qty-mas'), parseInt(mas.getAttribute('data-qty-n'), 10) + 1); return; }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') Carrito.cerrar();
    });
    Carrito.fetch();
  }

  /* ---------- Carruseles con flechas ---------- */
  function initCarriles() {
    $$('[data-carril]').forEach(function (sec) {
      var carril = $('.carril', sec);
      if (!carril) return;
      $$('[data-carril-prev]', sec).forEach(function (b) {
        b.addEventListener('click', function () { carril.scrollBy({ left: -520, behavior: 'smooth' }); });
      });
      $$('[data-carril-next]', sec).forEach(function (b) {
        b.addEventListener('click', function () { carril.scrollBy({ left: 520, behavior: 'smooth' }); });
      });
    });
  }

  /* ---------- Video ambiente (reduced-motion se queda en el póster) ---------- */
  function initVideos() {
    $$('video[data-ambiente]').forEach(function (v) {
      if (reducido) { v.removeAttribute('autoplay'); v.pause(); }
    });
  }

  /* ---------- Tarjeta de producto (render cliente) ---------- */
  function tarjetaHTML(p) {
    var badge = p.discount > 0 ? '<span class="tp-badge dato">−' + p.discount + '%</span>' : '';
    var low = p.lowStock && p.available ? '<span class="tp-low dato">Pocas unidades</span>' : '';
    var agotado = !p.available ? '<span class="tp-agotado dato">Agotado</span>' : '';
    var imgB = p.img2 ? '<img class="tp-b" src="' + esc(cdn(p.img2, 640)) + '" alt="" loading="lazy">' : '';
    var antes = p.compare && p.compare > p.price
      ? '<span class="antes tachado">' + fmtPesos(p.compare) + '</span>' : '';
    return '<li><a class="tp" href="/products/' + esc(p.handle) + '" data-cursor="ver">' +
      '<div class="tp-foto">' +
        (p.img ? '<img class="tp-a' + (p.img2 ? ' con-b' : '') + '" src="' + esc(cdn(p.img, 640)) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') +
        imgB + badge + low + agotado +
      '</div>' +
      '<div class="tp-info">' +
        '<h3 class="tp-nombre">' + esc(p.title) + '</h3>' +
        '<p class="tp-precio"><span class="actual">' + fmtPesos(p.price) + '</span>' + antes + '</p>' +
      '</div></a></li>';
  }

  /* ---------- Catálogo ---------- */
  function slimDesdeJson(p) {
    var vars = p.variants || [];
    var disponibles = vars.filter(function (v) { return v.available; });
    var v0 = disponibles[0] || vars[0] || {};
    var price = parseFloat(v0.price || '0');
    var compare = v0.compare_at_price ? parseFloat(v0.compare_at_price) : null;
    if (compare && compare <= price) compare = null;
    var noDisp = vars.filter(function (v) { return !v.available; }).length;
    return {
      handle: p.handle,
      title: p.title,
      type: p.product_type || '',
      vendor: p.vendor || '',
      price: price,
      compare: compare,
      discount: compare ? Math.round((compare - price) / compare * 100) : 0,
      available: disponibles.length > 0,
      lowStock: disponibles.length > 0 && vars.length > 0 && noDisp / vars.length >= 0.4,
      img: p.images && p.images[0] ? p.images[0].src : '',
      img2: p.images && p.images[1] ? p.images[1].src : ''
    };
  }

  function fetchColeccion(handle) {
    var out = [];
    function pagina(n) {
      return window.fetch('/collections/' + handle + '/products.json?limit=250&page=' + n)
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var ps = (d && d.products) || [];
          out = out.concat(ps);
          if (ps.length === 250 && n < 4) return pagina(n + 1);
          return out;
        });
    }
    return pagina(1);
  }

  function initCatalogo() {
    var raiz = $('[data-catalogo]');
    if (!raiz) return;
    var params = new URLSearchParams(location.search);
    var grupoId = params.get('g') || '';
    var orden = params.get('orden') || 'destacados';
    var grupos = [];
    try { grupos = JSON.parse(($('[data-grupos-json]') || {}).textContent || '[]'); } catch (e) {}
    var grid = $('[data-cat-grid]', raiz);
    var buscar = $('[data-cat-buscar]', raiz);
    var sel = $('[data-cat-orden]', raiz);
    var masBtn = $('[data-cat-mas]', raiz);
    var estado = { modo: 'liquid', lista: [], visibles: 36, q: '' };
    var POR_PAGINA = 36;

    if (sel) {
      sel.value = orden === 'descuento' ? 'descuento' : (params.get('sort_by') === 'price-ascending' ? 'precio-asc' : params.get('sort_by') === 'price-descending' ? 'precio-desc' : 'destacados');
      sel.addEventListener('change', function () {
        var v = sel.value;
        var url = new URL(location.href);
        url.searchParams.delete('orden');
        url.searchParams.delete('sort_by');
        url.searchParams.delete('page');
        if (v === 'descuento') url.searchParams.set('orden', 'descuento');
        if (v === 'precio-asc') url.searchParams.set('sort_by', 'price-ascending');
        if (v === 'precio-desc') url.searchParams.set('sort_by', 'price-descending');
        location.href = url.toString();
      });
    }

    function pintarCliente() {
      var lista = estado.lista;
      if (estado.q) {
        var q = norm(estado.q);
        lista = lista.filter(function (p) {
          return norm(p.title + ' ' + p.type + ' ' + p.vendor).indexOf(q) >= 0;
        });
      }
      if (orden === 'descuento') lista = lista.slice().sort(function (a, b) { return b.discount - a.discount; });
      if (sel && sel.value === 'precio-asc') lista = lista.slice().sort(function (a, b) { return a.price - b.price; });
      if (sel && sel.value === 'precio-desc') lista = lista.slice().sort(function (a, b) { return b.price - a.price; });
      lista = lista.filter(function (p) { return p.img; });
      lista = lista.filter(function (p) { return p.available; }).concat(lista.filter(function (p) { return !p.available; }));
      var n = $('[data-cat-n]');
      if (n) n.textContent = lista.length;
      var visibles = lista.slice(0, estado.visibles);
      if (!lista.length) {
        grid.innerHTML = '';
        var vacio = $('[data-cat-vacio]', raiz);
        if (vacio) vacio.hidden = false;
      } else {
        var vacio2 = $('[data-cat-vacio]', raiz);
        if (vacio2) vacio2.hidden = true;
        grid.innerHTML = visibles.map(tarjetaHTML).join('');
      }
      if (masBtn) {
        if (lista.length > estado.visibles) {
          masBtn.hidden = false;
          masBtn.textContent = 'Cargar más (' + (lista.length - estado.visibles) + ' restantes)';
          masBtn.onclick = function () { estado.visibles += POR_PAGINA; pintarCliente(); };
        } else {
          masBtn.hidden = true;
        }
      }
      var nativa = $('[data-cat-paginacion]', raiz);
      if (nativa) nativa.hidden = true;
    }

    function modoCliente(cargar) {
      if (estado.modo === 'cliente') { pintarCliente(); return; }
      estado.modo = 'cliente';
      var cargando = $('[data-cat-cargando]', raiz);
      if (cargando) cargando.hidden = false;
      cargar().then(function (productos) {
        var vistos = {};
        estado.lista = [];
        productos.forEach(function (p) {
          if (vistos[p.handle]) return;
          vistos[p.handle] = 1;
          estado.lista.push(slimDesdeJson(p));
        });
        if (cargando) cargando.hidden = true;
        pintarCliente();
      }).catch(function () {
        if (cargando) { cargando.textContent = 'No pudimos cargar el catálogo. Intenta de nuevo.'; }
      });
    }

    function cargarGrupo(g) {
      var seq = Promise.resolve([]);
      g.colecciones.forEach(function (h) {
        seq = seq.then(function (acc) {
          return fetchColeccion(h).then(function (ps) { return acc.concat(ps); });
        });
      });
      return seq;
    }

    // Modo grupo (?g=): unión de colecciones del grupo, renderizada en cliente
    if (grupoId) {
      var g = null;
      for (var i = 0; i < grupos.length; i++) if (grupos[i].id === grupoId) g = grupos[i];
      if (g) {
        var titulo = $('[data-cat-titulo]');
        if (titulo) titulo.textContent = g.nombre;
        var desc = $('[data-cat-desc]');
        if (desc) { desc.textContent = g.descripcion || ''; desc.hidden = !g.descripcion; }
        var todoChip = $('[data-chip-todo]', raiz);
        if (todoChip) todoChip.classList.remove('activa');
        var gChip = $('[data-grupo-chip="' + grupoId + '"]', raiz);
        if (gChip) gChip.classList.add('activa');
        var fila = $('[data-subcats="' + grupoId + '"]', raiz);
        if (fila) {
          fila.hidden = false;
          var todas = $('[data-subcat-todas]', fila);
          if (todas) todas.classList.add('activa');
        }
        $$('[data-subcats]', raiz).forEach(function (f) {
          if (f.getAttribute('data-subcats') !== grupoId) f.hidden = true;
        });
        modoCliente(function () { return cargarGrupo(g); });
      }
    } else if (orden === 'descuento') {
      modoCliente(function () { return fetchColeccion(raiz.getAttribute('data-coleccion') || 'all'); });
    }

    // Búsqueda en vivo dentro del catálogo (índice de la colección actual)
    if (buscar) {
      var tDeb = null;
      buscar.addEventListener('input', function () {
        clearTimeout(tDeb);
        tDeb = setTimeout(function () {
          estado.q = buscar.value.trim();
          estado.visibles = POR_PAGINA;
          if (estado.modo === 'cliente') { pintarCliente(); return; }
          if (!estado.q) return;
          var gAct = null;
          for (var i = 0; i < grupos.length; i++) if (grupos[i].id === grupoId) gAct = grupos[i];
          modoCliente(function () {
            return gAct ? cargarGrupo(gAct) : fetchColeccion(raiz.getAttribute('data-coleccion') || 'all');
          });
        }, 250);
      });
    }

    // "Cargar más" nativo: trae la siguiente página y añade las tarjetas
    if (masBtn && estado.modo === 'liquid') {
      masBtn.addEventListener('click', function (e) {
        if (estado.modo !== 'liquid') return;
        var sig = masBtn.getAttribute('data-siguiente');
        if (!sig) return;
        e.preventDefault();
        masBtn.disabled = true;
        window.fetch(sig).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nuevos = doc.querySelectorAll('[data-cat-grid] > li');
          nuevos.forEach(function (li) { grid.appendChild(document.importNode(li, true)); });
          var btnNuevo = doc.querySelector('[data-cat-mas]');
          var sigNueva = btnNuevo && btnNuevo.getAttribute('data-siguiente');
          if (sigNueva) {
            masBtn.setAttribute('data-siguiente', sigNueva);
            masBtn.textContent = btnNuevo.textContent;
            masBtn.disabled = false;
          } else {
            masBtn.hidden = true;
          }
        }).catch(function () { masBtn.disabled = false; });
      });
    }
  }

  /* ---------- Ficha de producto ---------- */
  function initPdp() {
    var raiz = $('[data-pdp]');
    if (!raiz) return;
    var datos;
    try { datos = JSON.parse($('[data-pdp-json]').textContent); } catch (e) { return; }
    // Liquid emite centinelas null al final de arreglos condicionales — fuera
    datos.images = (datos.images || []).filter(Boolean);
    datos.accesorios = (datos.accesorios || []).filter(Boolean).map(function (a) {
      a.variantes = (a.variantes || []).filter(Boolean);
      return a;
    }).filter(function (a) { return a.variantes.length > 0; });

    var sel = {};
    datos.options.forEach(function (o, i) {
      var v0 = null;
      for (var k = 0; k < datos.variants.length; k++) {
        if (datos.variants[k].available) { v0 = datos.variants[k]; break; }
      }
      if (!v0) v0 = datos.variants[0];
      sel[o.name] = (v0 && v0.opts[i]) || o.values[0];
    });

    var imgIdx = 0;
    var iniciales = '';
    var sinIniciales = false;
    var faltaIniciales = false;
    var medidas = {}; // src -> { oscura, color, frontal } de cada foto
    var accSel = {}; // handle -> variantId

    function varianteActiva() {
      if (!datos.options.length) return datos.variants[0];
      for (var i = 0; i < datos.variants.length; i++) {
        var v = datos.variants[i], ok = true;
        for (var j = 0; j < datos.options.length; j++) {
          if (v.opts[j] !== sel[datos.options[j].name]) { ok = false; break; }
        }
        if (ok) return v;
      }
      return null;
    }

    function nombreVariante() {
      if (!datos.options.length) return '';
      return datos.options.map(function (o) { return o.name + ': ' + sel[o.name]; }).join(' · ');
    }

    function etiquetaIniciales() {
      if (!datos.personalizable) return '';
      return (sinIniciales || !iniciales) ? 'Sin iniciales' : 'Iniciales: ' + iniciales;
    }

    function eligioIniciales() {
      return !datos.personalizable || sinIniciales || iniciales.length > 0;
    }

    /* Galería */
    var fotoPrincipal = $('[data-pdp-foto] img', raiz);
    var minis = $$('[data-pdp-mini]', raiz);
    function ponerFoto(i) {
      imgIdx = i;
      if (fotoPrincipal && datos.images[i]) {
        fotoPrincipal.src = cdn(datos.images[i], 1100);
        fotoPrincipal.alt = datos.title + ' — imagen ' + (i + 1);
      }
      minis.forEach(function (m, k) {
        m.classList.toggle('activa', k === i);
        m.setAttribute('aria-current', k === i ? 'true' : 'false');
      });
      medirYPintar();
    }
    minis.forEach(function (m, i) {
      m.addEventListener('click', function () { ponerFoto(i); });
    });

    /* Zona del monograma medida en canvas (CDN Shopify da CORS *):
       luminancia + color de tela por promedio intercuartil (el monograma
       impreso queda fuera) + desviación estándar. Zona movida (foto de
       ambiente) = el preview usa la foto frontal como referencia. */
    function medirZona(src, listo) {
      if (!src || medidas[src]) { if (listo) listo(); return; }
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        try {
          var s = 24, c = document.createElement('canvas');
          c.width = s; c.height = s;
          var ctx = c.getContext('2d');
          if (ctx) {
            var W = img.naturalWidth, H = img.naturalHeight;
            ctx.drawImage(img, W * 0.3, H * 0.32, W * 0.4, H * 0.36, 0, 0, s, s);
            var d = ctx.getImageData(0, 0, s, s).data;
            var px = [];
            for (var i = 0; i < d.length; i += 4) {
              px.push({ r: d[i], g: d[i + 1], b: d[i + 2], l: 0.2126 * d[i] + 0.7152 * d[i + 1] + 0.0722 * d[i + 2] });
            }
            px.sort(function (a, b) { return a.l - b.l; });
            var q = px.slice(Math.floor(px.length * 0.25), Math.ceil(px.length * 0.75));
            var r = 0, g = 0, bl = 0, l = 0;
            q.forEach(function (p) { r += p.r; g += p.g; bl += p.b; l += p.l; });
            var n = q.length || 1;
            // Foto frontal de producto = esquinas superiores con fondo de
            // estudio claro; de ambiente = escena (oscuras/variadas).
            var esquina = function (x0) {
              ctx.drawImage(img, W * x0, H * 0.05, W * 0.16, H * 0.14, 0, 0, 8, 8);
              var e = ctx.getImageData(0, 0, 8, 8).data;
              var acc = 0;
              for (var k = 0; k < e.length; k += 4) acc += 0.2126 * e[k] + 0.7152 * e[k + 1] + 0.0722 * e[k + 2];
              return acc / (e.length / 4);
            };
            var tl = esquina(0.06), tr = esquina(0.78);
            medidas[src] = {
              oscura: l / n < 120,
              color: [Math.round(r / n), Math.round(g / n), Math.round(bl / n)],
              frontal: tl > 175 && tr > 175
            };
          }
        } catch (e) { /* canvas tainted → queda el parche blur de respaldo */ }
        if (listo) listo();
      };
      img.onerror = function () { if (listo) listo(); };
      img.src = cdn(src, 96);
    }

    /* Foto del cajón de preview: la actual si es toma frontal de estudio;
       si es de ambiente, la PRIMERA frontal del set (se buscan todas);
       si el producto no tiene ninguna frontal, letras sin parche. */
    var frontalIdx = null; // null = sin buscar · -1 = ninguna · n = índice
    function buscarFrontal(i, fin) {
      if (i >= datos.images.length) { frontalIdx = -1; fin(); return; }
      var s = datos.images[i];
      medirZona(s, function () {
        var m = medidas[s];
        if (m && m.frontal) { frontalIdx = i; fin(); }
        else { buscarFrontal(i + 1, fin); }
      });
    }

    function srcPreview() {
      var cur = datos.images[imgIdx];
      var m = medidas[cur];
      if (!m || m.frontal) return cur;
      if (frontalIdx !== null && frontalIdx >= 0) return datos.images[frontalIdx];
      return cur;
    }

    function medirYPintar() {
      if (!datos.personalizable) return;
      pintarIniciales();
      var cur = datos.images[imgIdx];
      medirZona(cur, function () {
        var m = medidas[cur];
        if (m && !m.frontal && frontalIdx === null) {
          buscarFrontal(0, pintarIniciales);
        } else {
          pintarIniciales();
        }
      });
    }

    function bolsoOscuro() {
      var m = medidas[srcPreview()];
      if (m) return m.oscura;
      var color = '';
      datos.options.forEach(function (o) {
        if (/color/i.test(o.name)) color = (sel[o.name] || '').trim().toLowerCase();
      });
      return /^(negro|mocca|moca|vinotinto|marr[oó]n|chocolate|caramelo|caf[eé])/.test(color);
    }

    function pintarIniciales() {
      if (!datos.personalizable) return;
      var caja = $('[data-inic]', raiz);
      var letras = $('[data-inic-letras]', raiz);
      var parche = $('[data-inic-parche]', raiz);
      var sello = $('[data-inic-sello]', raiz);
      var err = $('[data-inic-error]', raiz);
      var muestra = !!iniciales && !sinIniciales;
      var prevImg = $('[data-inic-foto]', raiz);
      var elegido = srcPreview();
      if (prevImg && elegido) {
        var quiere = cdn(elegido, 352);
        if (prevImg.getAttribute('src') !== quiere) prevImg.src = quiere;
      }
      if (letras) {
        letras.hidden = !muestra;
        letras.textContent = iniciales;
        var oscuro = bolsoOscuro();
        letras.style.color = oscuro ? '#f4efe6' : '#43301f';
        letras.style.textShadow = oscuro
          ? '0 1px 2px rgba(0,0,0,0.5), 0 0 1px rgba(0,0,0,0.4)'
          : '0 1px 1px rgba(255,255,255,0.5), 0 -1px 1px rgba(0,0,0,0.2)';
      }
      if (parche) {
        var med = medidas[elegido];
        if (med && med.frontal) {
          // Tela lisa: parche del color real del bolso
          parche.hidden = !muestra;
          var rgb = med.color.join(',');
          parche.classList.add('con-color');
          parche.style.background = 'radial-gradient(ellipse at center, rgba(' + rgb + ',0.98) 50%, rgba(' + rgb + ',0.9) 68%, rgba(' + rgb + ',0) 88%)';
        } else if (med) {
          // Foto de ambiente sin frontal disponible: letras solas, sin manchón
          parche.hidden = true;
          parche.classList.remove('con-color');
          parche.style.background = '';
        } else {
          // Aún sin medir: blur suave de respaldo
          parche.hidden = !muestra;
          parche.classList.remove('con-color');
          parche.style.background = '';
        }
      }
      if (sello) sello.hidden = !muestra;
      if (caja) caja.classList.toggle('falta', faltaIniciales && !eligioIniciales());
      if (err) err.hidden = !(faltaIniciales && !eligioIniciales());
    }

    var inicInput = $('[data-inic-input]', raiz);
    var inicCheck = $('[data-inic-sin]', raiz);
    if (inicInput) {
      inicInput.addEventListener('input', function () {
        var v = inicInput.value.replace(/[^a-zA-ZñÑ]/g, '').toUpperCase().slice(0, 2);
        inicInput.value = v;
        iniciales = v;
        if (v) faltaIniciales = false;
        pintarIniciales();
      });
    }
    if (inicCheck) {
      inicCheck.addEventListener('change', function () {
        sinIniciales = inicCheck.checked;
        if (sinIniciales) {
          iniciales = '';
          if (inicInput) { inicInput.value = ''; inicInput.disabled = true; }
          faltaIniciales = false;
        } else if (inicInput) {
          inicInput.disabled = false;
        }
        pintarIniciales();
      });
    }
    function pedirIniciales() {
      faltaIniciales = true;
      pintarIniciales();
      if (inicInput) {
        inicInput.scrollIntoView({ behavior: reducido ? 'auto' : 'smooth', block: 'center' });
        inicInput.focus({ preventScroll: true });
      }
    }

    /* Variantes */
    function pintarVariante() {
      var v = varianteActiva();
      // La galería salta sola a la foto de la variante elegida (si tiene)
      if (v && typeof v.img === 'number' && v.img >= 0 && v.img !== imgIdx && datos.images[v.img]) {
        ponerFoto(v.img);
      }
      var precio = v ? v.price : datos.price;
      var compare = v ? v.compare : datos.compare;
      var disponible = v ? v.available : false;
      var ahorro = compare && compare > precio ? compare - precio : 0;
      var pct = ahorro && compare ? Math.round(ahorro / compare * 100) : 0;
      $$('[data-pdp-precio]', raiz).forEach(function (el) { el.textContent = fmtCop(precio); });
      $$('[data-pdp-antes]', raiz).forEach(function (el) {
        el.hidden = !(compare && compare > precio);
        el.textContent = compare ? fmtCop(compare) : '';
      });
      var ah = $('[data-pdp-ahorro]', raiz);
      if (ah) {
        ah.hidden = !ahorro;
        ah.textContent = ahorro ? 'Ahorras ' + fmtCop(ahorro) : '';
      }
      var badge = $('[data-pdp-badge]', raiz);
      if (badge) { badge.hidden = !pct; badge.textContent = '−' + pct + '%'; }
      $$('[data-pdp-agregar]', raiz).forEach(function (b) {
        b.disabled = !disponible;
        b.textContent = disponible ? (b.getAttribute('data-txt') || 'Agregar al equipaje') : 'Agotado';
        b.classList.toggle('agotado', !disponible);
      });
      datos.options.forEach(function (o, oi) {
        $$('[data-vchip][data-opcion="' + oi + '"]', raiz).forEach(function (ch) {
          var val = ch.getAttribute('data-valor');
          var activa = sel[o.name] === val;
          ch.classList.toggle('activa', activa);
          ch.setAttribute('aria-pressed', activa ? 'true' : 'false');
          var combo = null;
          for (var i = 0; i < datos.variants.length; i++) {
            var va = datos.variants[i], ok = true;
            for (var j = 0; j < datos.options.length; j++) {
              var esperado = j === oi ? val : sel[datos.options[j].name];
              if (va.opts[j] !== esperado) { ok = false; break; }
            }
            if (ok) { combo = va; break; }
          }
          var agotada = !combo || !combo.available;
          ch.classList.toggle('agotada', agotada);
          var suf = $('.suf', ch);
          if (suf) suf.hidden = !agotada;
        });
        var leg = $('[data-sel-opcion="' + oi + '"]', raiz);
        if (leg) leg.textContent = sel[o.name];
      });
      var wa = $('[data-pdp-wa]', raiz);
      if (wa) wa.href = waUrl(mensajeWA(precio));
      var bbPrecio = $('[data-buybar-precio]', raiz);
      if (bbPrecio) bbPrecio.textContent = fmtCop(precio);
      var bbAntes = $('[data-buybar-antes]', raiz);
      if (bbAntes) {
        bbAntes.hidden = !(compare && compare > precio);
        bbAntes.textContent = compare ? fmtCop(compare) : '';
      }
    }

    document.addEventListener('click', function (e) {
      var ch = e.target.closest('[data-vchip]');
      if (!ch) return;
      var oi = parseInt(ch.getAttribute('data-opcion'), 10);
      sel[datos.options[oi].name] = ch.getAttribute('data-valor');
      pintarVariante();
    });

    /* Cross-sell accesorios */
    function accesoriosElegidos() {
      var out = [];
      Object.keys(accSel).forEach(function (h) {
        var acc = null;
        (datos.accesorios || []).forEach(function (a) { if (a.handle === h) acc = a; });
        if (!acc) return;
        var v = null;
        acc.variantes.forEach(function (x) { if (x.id === accSel[h]) v = x; });
        if (!v) v = acc.variantes[0];
        out.push({ acc: acc, v: v });
      });
      return out;
    }
    function pintarCross() {
      var total = 0;
      accesoriosElegidos().forEach(function (par) { total += par.v.price; });
      var totalEl = $('[data-cross-total]', raiz);
      if (totalEl) {
        totalEl.hidden = total === 0;
        var st = $('strong', totalEl);
        if (st) st.textContent = '+' + fmtCop(total);
      }
      $$('[data-cross-item]', raiz).forEach(function (li) {
        var h = li.getAttribute('data-cross-item');
        var marcado = accSel[h] !== undefined;
        li.classList.toggle('marcado', marcado);
        var s = $('select', li);
        if (s) s.hidden = !marcado || s.options.length < 2;
      });
      var v = varianteActiva();
      var wa = $('[data-pdp-wa]', raiz);
      if (wa) wa.href = waUrl(mensajeWA(v ? v.price : datos.price));
    }
    $$('[data-cross-check]', raiz).forEach(function (chk) {
      chk.addEventListener('change', function () {
        var h = chk.getAttribute('data-cross-check');
        if (chk.checked) {
          var acc = null;
          (datos.accesorios || []).forEach(function (a) { if (a.handle === h) acc = a; });
          accSel[h] = acc && acc.variantes[0] ? acc.variantes[0].id : undefined;
        } else {
          delete accSel[h];
        }
        pintarCross();
      });
    });
    $$('[data-cross-var]', raiz).forEach(function (s) {
      s.addEventListener('change', function () {
        accSel[s.getAttribute('data-cross-var')] = parseInt(s.value, 10);
        pintarCross();
      });
    });

    function mensajeWA(precio) {
      var partes = ['Hola SACS.A 👋 Me interesa: ' + datos.title +
        (nombreVariante() ? ' (' + nombreVariante() + ')' : '') +
        (etiquetaIniciales() ? ' · ' + etiquetaIniciales() : '') +
        ' — ' + fmtCop(precio) + '.'];
      accesoriosElegidos().forEach(function (par) {
        partes.push('+ ' + par.acc.title + (par.v.title !== 'Default Title' ? ' (' + par.v.title + ')' : '') + ' — ' + fmtCop(par.v.price));
      });
      partes.push('¿Está disponible?');
      return partes.join('\n');
    }

    /* Agregar al equipaje */
    function agregar() {
      var v = varianteActiva();
      if (!v || !v.available) return;
      if (!eligioIniciales()) { pedirIniciales(); return; }
      var items = [];
      var props = null;
      if (datos.personalizable) {
        props = { 'Iniciales': (sinIniciales || !iniciales) ? 'Sin iniciales' : iniciales };
      }
      var linea = { id: v.id, quantity: 1 };
      if (props) linea.properties = props;
      items.push(linea);
      accesoriosElegidos().forEach(function (par) {
        items.push({ id: par.v.id, quantity: 1 });
      });
      $$('[data-pdp-agregar]', raiz).forEach(function (b) { b.disabled = true; });
      Carrito.add(items).catch(function () {}).then(function () {
        pintarVariante();
      });
    }
    $$('[data-pdp-agregar]', raiz).forEach(function (b) {
      b.addEventListener('click', agregar);
    });
    var waBtn = $('[data-pdp-wa]', raiz);
    if (waBtn) {
      waBtn.addEventListener('click', function (e) {
        if (!eligioIniciales()) { e.preventDefault(); pedirIniciales(); }
      });
    }

    /* Barra de compra móvil */
    var acciones = $('[data-pdp-acciones]', raiz);
    if (acciones && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var en = entries[0];
        var visible = !en.isIntersecting && en.boundingClientRect.top < 0;
        if (visible) document.body.setAttribute('data-buybar', '1');
        else document.body.removeAttribute('data-buybar');
      }, { threshold: 0 });
      io.observe(acciones);
    }

    /* Cuenta regresiva de despacho */
    var cuenta = $('[data-pdp-despacho]', raiz);
    if (cuenta) {
      var tickDespacho = function () {
        var e = estadoDespacho();
        cuenta.innerHTML = e.saleHoy
          ? 'Pide antes de las <strong>6:00 p. m.</strong> y sale hoy — faltan <strong>' + formatoRestante(e.msRestante) + '</strong>'
          : 'Pide ahora y tu pedido sale el <strong>próximo día hábil</strong>';
      };
      tickDespacho();
      setInterval(tickDespacho, 30000);
    }

    pintarVariante();
    pintarCross();
    medirYPintar();
  }

  /* ---------- Pase de ofertas (Gate 34) ---------- */
  function initPase() {
    var el = $('#pase-ofertas');
    if (!el) return;
    if (ss('sacs-pase-visto')) { el.remove(); return; }
    var mostrado = false;
    function mostrar() {
      if (mostrado) return;
      mostrado = true;
      ss('sacs-pase-visto', '1');
      el.hidden = false;
      el.classList.add('entra');
    }
    var t = setTimeout(mostrar, 14000);
    document.addEventListener('mouseleave', function (e) {
      if (e.clientY <= 0) mostrar();
    });
    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-pase-cerrar]')) {
        clearTimeout(t);
        el.hidden = true;
      }
    });
  }

  /* ---------- Toast de despacho ---------- */
  function initDespachoToast() {
    var el = $('#despacho-toast');
    if (!el) return;
    if (ss('sacs-despacho-visto')) { el.remove(); return; }
    if (!estadoDespacho().saleHoy) { el.remove(); return; }
    setTimeout(function () {
      ss('sacs-despacho-visto', '1');
      var e = estadoDespacho();
      if (!e.saleHoy) return;
      var r = $('[data-despacho-restante]', el);
      if (r) r.textContent = formatoRestante(e.msRestante);
      el.hidden = false;
      el.classList.add('entra');
      setTimeout(function () { el.hidden = true; }, 8000);
      var tick = setInterval(function () {
        var e2 = estadoDespacho();
        if (!e2.saleHoy) { el.hidden = true; clearInterval(tick); return; }
        if (r) r.textContent = formatoRestante(e2.msRestante);
      }, 30000);
    }, 5000);
    el.addEventListener('click', function (e) {
      if (e.target.closest('[data-despacho-cerrar]')) el.hidden = true;
    });
  }

  /* ---------- Formulario de contacto → WhatsApp ---------- */
  function initContacto() {
    var form = $('[data-form-wa]');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var nombre = (form.querySelector('[name="nombre"]') || {}).value || '…';
      var tema = (form.querySelector('[name="tema"]') || {}).value || 'Pedido';
      var mensaje = (form.querySelector('[name="mensaje"]') || {}).value || '';
      window.open(waUrl('Hola SACS.A 👋 Soy ' + nombre + '.\nTema: ' + tema + '\n\n' + mensaje), '_blank', 'noopener,noreferrer');
    });
  }

  /* ---------- Arranque ---------- */
  function init() {
    initIntro();
    $$('[data-flap]').forEach(function (el) {
      if (!el.closest('[data-intro]')) initFlap(el);
    });
    initCursor();
    initNav();
    initCarrito();
    initCarriles();
    initVideos();
    initReveal(document);
    initCatalogo();
    initPdp();
    initPase();
    initDespachoToast();
    initContacto();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init al recargar secciones en el editor de temas
  document.addEventListener('shopify:section:load', function (e) {
    initReveal(e.target);
    $$('[data-flap]', e.target).forEach(initFlap);
  });
})();
